export const stDesk = {
  containComp: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
    height: 'auto',
    width: 'calc(100% - 20px)',
    borderRadius: '14px',
    overflow: 'hidden', // Garante que os cantos do interno fiquem alinhados
    boxShadow: '0px 0px 8px 0px rgba(0,0,0,0.2)',
    border: '2px solid var(--color-text-hig)',
    cursor: 'pointer',
    margin: '10px',
  },
  containHeader: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'flex-start',
    alignItems: 'center',
    width: '100%', // Garante que o elemento interno ocupe toda a largura
    backgroundPosition: 'center',
    backgroundSize: 'cover',
  },
  containNight: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'flex-start',
    alignItems: 'center',
    width: '100%', // Garante que o elemento interno ocupe toda a largura
    backgroundColor: 'rgba(0,0,0,0.6)',
    padding: '8px 10px 25px 8px',
  },
  imagem: {
    width: '70px',
    height: '70px',
    marginRight: '8px',
    borderRadius: '50%',
    objectFit: 'cover',
  },
  containBottom: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'flex-start',
    width: '100%',
    backgroundColor: 'var(--color-text-sec)',
    borderRadius: '14px 14px 0px 0px',
    marginTop: '-14px',
    padding: '5px 10px',
  },
  containResumo: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'flex-start',
    alignItems: 'center',
    height: '100%',
    width: 'auto',
    marginLeft: '5px',
  },
}

export const st = {
  contain: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    height: 'auto',
    width: 'auto',
    borderRadius: '14px',
    // colocar imagem de fundo
    backgroundPosition: 'center',
    backgroundSize: 'cover',
    // escurecer imagem de fundo
    boxShadow: '0px 0px 8px 0px rgba(0,0,0,0.2)',
    marginRight: '5px',
    cursor: 'pointer',
  },
  containCenter: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    width: '230px',
    borderRadius: '14px',
    // escurecer imagem de fundo
    backgroundColor: 'rgba(0,0,0,0.6)',
    boxShadow: '0px 0px 8px 0px rgba(0,0,0,0.2)',
    padding: '8px',
  },
  imagem: {
    width: '50px',
    height: '50px',
    marginRight: '8px',
    borderRadius: '50%',
    objectFit: 'cover',
  },
  containText: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'flex-start',
    alignItems: 'flex-start',
    width: 'calc(100% - 55px)',
  },
  title: {
    fontSize: '1.2rem',
    fontWeight: 'bold',
    color: 'var(--color-text-hig)',
    fontFamily: 'var(--font-jost-light)',

    // Adiciona sombra ao texto
    textShadow: '0px 0px 4px rgba(0,0,0,0.5)',

    // Estilo para cortar texto excedente e adicionar "..."
    whiteSpace: 'nowrap',
    overflow: 'hidden',
    textOverflow: 'ellipsis',

    // Define um tamanho máximo do container para funcionar corretamente
    maxWidth: '100%', // Pode ser um valor fixo como '200px' se necessário
  },

  subtitle: {
    fontSize: '1rem',
    fontWeight: 'bold',
    color: 'var(--color-text-sec)',
    fontFamily: 'var(--font-jost-light)',
    // Adiciona sombra ao texto
    textShadow: '0px 0px 4px rgba(0,0,0,0.5)',

    // Estilo para cortar texto excedente e adicionar "..."
    whiteSpace: 'nowrap',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    // Define um tamanho máximo do container para funcionar corretamente
    maxWidth: '100%', // Pode ser um valor fixo como '200px' se necessário
  },
  text: {
    width: '100%',
    alignText: 'left',
    fontSize: '1.0rem',
    fontWeight: 'bold',
    color: 'var(--color-text-pri)',
    fontFamily: 'var(--font-jost-mediun)',
    marginBottom: '8px',
    // Adiciona sombra ao texto
  },
  subText: {
    width: '100%',
    alignText: 'left',
    fontSize: '0.9rem',
    fontWeight: 'bold',
    color: 'var(--color-text-pri)',
    fontFamily: 'var(--font-jost-light)',
    // Adiciona sombra ao texto
  },
}
